'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _inflIcons = require('infl-icons');

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _action = require('./action');

var _action2 = _interopRequireDefault(_action);

var _detail = require('./detail');

var _detail2 = _interopRequireDefault(_detail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var typeToIconMap = {
  success: 'check-circle-o',
  error: 'exclamation-circle-o',
  warning: 'info-circle-o'
};

var Alert = function (_Component) {
  _inherits(Alert, _Component);

  function Alert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Alert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Alert.__proto__ || Object.getPrototypeOf(Alert)).call.apply(_ref, [this].concat(args))), _this), _this.icon = function () {
      return typeToIconMap[_this.props.type] || 'alert-caution';
    }, _this.classes = function () {
      return (0, _classnames2.default)(_styles2.default.alert, _styles2.default[_this.props.type]);
    }, _this.contentClasses = function () {
      return (0, _classnames2.default)(_styles2.default.content, _defineProperty({}, _styles2.default.verticalLayout, _this.props.action && _this.props.action.position === 'bottom'));
    }, _this.render = function () {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          title = _this$props.title,
          children = _this$props.children,
          showIcon = _this$props.showIcon,
          action = _this$props.action;


      return _react2.default.createElement(
        'div',
        { className: _this.classes() },
        showIcon && _react2.default.createElement(
          'span',
          { className: _styles2.default.icon },
          _react2.default.createElement(_inflIcons.Icon, { icon: _this.icon() })
        ),
        _react2.default.createElement(
          'div',
          { className: _this.contentClasses() },
          _react2.default.createElement(
            'div',
            { className: _styles2.default.titleAndBody },
            title && _react2.default.createElement(
              'h4',
              null,
              title
            ),
            _react2.default.createElement(
              'div',
              { className: _styles2.default.body },
              children
            )
          ),
          action && _react2.default.createElement(_action2.default, { onClick: action.onClick, title: action.title })
        ),
        onClose && _react2.default.createElement(
          'span',
          { className: _styles2.default.close, onClick: onClose },
          _react2.default.createElement(_inflIcons.Icon, { icon: 'close' })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return Alert;
}(_react.Component);

Alert.propTypes = {
  title: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['success', 'error', 'info', 'warning']),
  showIcon: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  action: _propTypes2.default.shape({
    onClick: _propTypes2.default.func.isRequired,
    title: _propTypes2.default.string.isRequired,
    position: _propTypes2.default.oneOf(['right', 'bottom'])
  })
};
Alert.defaultProps = {
  title: '',
  type: 'info',
  showIcon: false
};


Alert.Detail = _detail2.default;

exports.default = Alert;